import { CodeBlock } from '../../../../shared-components';
import { IGetEnvironmentResponse } from '../../../../models/environmentModel';
import { devSettings } from '../../../../../@xmcloud/core/messages/en';
import { environment } from '../../../../config/envConfig';
import { EnvironmentClass } from '../../../../../@xmcloud/utils/constants';
import {
	buildEdgePlatformHostnameLines,
	buildEdgeUrlLine,
	buildOptionalSecretLine,
	pickContextId,
} from './developerSettingsEnvVars';

const { editingSecretNotFound } = devSettings;
const { prod: PRODUCTION } = EnvironmentClass;

export const ContentSdkSettings: React.FC<{
	environmentDetail: IGetEnvironmentResponse;
	isPreview: boolean;
	siteName: string;
	editingSecret: string;
	isEditingSecretAvailable: boolean;
	sdkVariant?: '1.0' | '2.0+';
}> = ({
	environmentDetail,
	isPreview,
	siteName,
	editingSecret,
	isEditingSecretAvailable,
	sdkVariant = '1.0',
}) => {
	const previewContextId = environmentDetail?.previewContextId || '';
	const liveContextId = environmentDetail?.liveContextId || '';
	const isProduction = environment === PRODUCTION;
	const contextId = pickContextId(isPreview, previewContextId, liveContextId);
	const includeEdgeHostnames = sdkVariant === '2.0+';

	const envVariablesLines = [
		...(!includeEdgeHostnames ? buildEdgeUrlLine(isProduction) : []),
		`SITECORE_EDGE_CONTEXT_ID=${contextId}`,
		`NEXT_PUBLIC_SITECORE_EDGE_CONTEXT_ID=${contextId}`,
		...(includeEdgeHostnames
			? buildEdgePlatformHostnameLines(isProduction)
			: []),
		`NEXT_PUBLIC_DEFAULT_SITE_NAME=${siteName}`,
		...buildOptionalSecretLine({
			isPreview,
			isAvailable: isEditingSecretAvailable,
			variableName: 'SITECORE_EDITING_SECRET',
			value: editingSecret,
			notFoundText: editingSecretNotFound,
		}),
	];

	return (
		<CodeBlock
			items={envVariablesLines}
			clipboardText={envVariablesLines.join('\n')}
			data-testid="code-block"
			key="content-sdk-code-block"
		/>
	);
};
